import api from "lib/axios";
import type { ApiEnvelope, PaginatedResult } from "services/apiTypes";
import { unwrapList } from "services/apiTypes";

export type GuestSubject = {
  id: number;
  name?: string | null;
  title?: string | null;
  stage_id?: number | null;
  stage_ids?: number[];
};

export const guestSubjectsService = {
  async list(params: Record<string, unknown> = {}) {
    // Backend: Route::prefix('guest')->get('subjects', ...)
    // Frontend baseURL already includes `/api`, so path is `/guest/subjects`.
    const res = await api.get<ApiEnvelope<PaginatedResult<GuestSubject>>>("/guest/subjects", {
      params,
      meta: { toastSuccess: false },
    });
    return unwrapList<GuestSubject>(res.data).data;
  },
};
